<template>
    <div class="cert-item d-flex flex-column user-select-none" :class="{ expired: isExpired }">
        <div>
            <div class="float-right tg-1 period">
                <span :class="{ 'text-success': !isExpired, 'text-danger': isExpired }" class="mr-1">
                    <i v-if="isExpired" class="fas fa-exclamation-circle"></i>
                    <i v-else class="fas fa-check-circle"></i>
                </span>

                <span v-if="isExpired">{{ $l("platon.eimzo_validity_expired", "Муддати тугаган") }},</span>
                <span v-else>{{ $l("platon.eimzo_validity_active", "Фаол") }},</span>

                <span class="ml-1">{{ validPeriod }}</span>
            </div>

            <div v-if="isLegalEntity" class="cert-text">{{ $l("platon.eimzo_tin", "СТИР") }} {{ cert.TIN }}</div>

            <div v-else-if="cert.PINFL" class="cert-text">{{ $l("platon.eimzo_pinfl", "ЖШШИР") }} {{ cert.PINFL }}</div>

            <div v-if="isLegalEntity">
                <div class="cert-org">{{ cert.O }}</div>
                <div class="cert-owner-name">{{ cert.CN }}</div>
            </div>

            <div v-else>
                <div class="cert-owner-name">{{ cert.CN }}</div>
                <div class="cert-org">{{ cert.O }}</div>
            </div>

            <div class="cert-text">
                {{ certType }}
            </div>
        </div>

        <div style="position: absolute; bottom: 12px; right: 12px">
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M34.1358 8.5675C33.9825 8.5675 33.8387 8.52917 33.695 8.46209C30.0246 6.56459 26.8333 5.75 23.0191 5.75C19.2146 5.75 15.6304 6.66042 12.3433 8.4525C11.8737 8.70167 11.2987 8.53875 11.04 8.06917C10.7908 7.59959 10.9537 7.02459 11.4233 6.76584C14.9979 4.82042 18.8983 3.83334 23.0191 3.83334C27.1016 3.83334 30.6666 4.73417 34.5766 6.75625C35.0462 6.99584 35.2283 7.58042 34.9887 8.05C34.8162 8.37584 34.4808 8.5675 34.1358 8.5675ZM6.7083 18.63C6.51664 18.63 6.32497 18.5725 6.15247 18.4575C5.72122 18.1508 5.6158 17.5567 5.92247 17.1254C7.81997 14.4421 10.2446 12.3338 13.1196 10.8483C19.1475 7.73375 26.8525 7.72417 32.89 10.8292C35.7554 12.305 38.1704 14.3942 40.0775 17.0583C40.3841 17.4896 40.2883 18.0838 39.8571 18.3904C39.4258 18.6971 38.8221 18.6013 38.5154 18.17C36.7904 15.755 34.6054 13.8575 32.0179 12.535C26.5171 9.70792 19.4925 9.7175 14.0012 12.5542C11.4041 13.8958 9.20955 15.8029 7.49414 18.2371C7.30247 18.4958 7.00539 18.63 6.7083 18.63ZM18.6971 41.7546C18.4479 41.7546 18.2083 41.6588 18.0166 41.4671C16.3587 39.79 15.4579 38.7263 14.1641 36.4167C12.8416 34.0592 12.1421 31.1746 12.1421 28.0888C12.1421 22.3963 17.0104 17.7579 23 17.7579C28.9896 17.7579 33.8579 22.3867 33.8579 28.0888C33.8579 28.6158 33.4266 29.0471 32.8996 29.0471C32.3725 29.0471 31.9412 28.6158 31.9412 28.0888C31.9412 23.4504 27.9354 19.6746 23 19.6746C18.0741 19.6746 14.0587 23.4504 14.0587 28.0888C14.0587 30.8488 14.6721 33.3979 15.8316 35.4775C17.0679 37.6817 17.8921 38.6304 19.3679 40.1158C19.7416 40.4896 19.7416 41.1029 19.3583 41.4671C19.1858 41.6683 18.9366 41.7546 18.6971 41.7546ZM32.43 38.2088C30.1491 38.2088 28.1462 37.6338 26.4883 36.5125C23.6421 34.5767 21.9362 31.4333 21.9362 28.0983C21.9362 27.5713 22.3675 27.14 22.8946 27.14C23.4216 27.14 23.8529 27.5713 23.8529 28.0983C23.8529 30.7913 25.2425 33.3404 27.5712 34.9217C28.9225 35.8417 30.5133 36.2921 32.43 36.2921C32.89 36.2921 33.6662 36.2442 34.4329 36.11C34.9504 36.0142 35.4487 36.3688 35.5446 36.8863C35.6404 37.4038 35.2858 37.9021 34.7683 37.9979C33.6471 38.1992 32.6983 38.2088 32.43 38.2088ZM28.5679 42.1667C28.4816 42.1667 28.3954 42.1571 28.3187 42.1283C25.2616 41.2946 23.2683 40.1638 21.1983 38.1033C18.5246 35.4392 17.0487 31.8838 17.0487 28.0983C17.0487 24.9838 19.6937 22.4538 22.9521 22.4538C26.2104 22.4538 28.8554 24.9838 28.8554 28.0983C28.8554 30.1492 30.6475 31.8263 32.8421 31.8263C35.0366 31.8263 36.8287 30.1588 36.8287 28.0983C36.8287 20.8725 30.5996 14.9979 22.9425 14.9979C17.4896 14.9979 12.5158 18.0263 10.2733 22.7221C9.5258 24.2746 9.15205 26.0858 9.15205 28.0983C9.15205 29.5933 9.28622 31.9508 10.4266 35.0079C10.6087 35.5063 10.3596 36.0525 9.86122 36.2442C9.36289 36.4263 8.81664 36.1771 8.62497 35.6788C7.6858 33.1583 7.2258 30.6858 7.2258 28.0983C7.2258 25.7983 7.66664 23.7092 8.53872 21.8979C11.0975 16.5504 16.7516 13.0908 22.9329 13.0908C31.6441 13.0908 38.7358 19.8279 38.7358 28.1079C38.7358 31.2225 36.0812 33.7525 32.8325 33.7525C29.5837 33.7525 26.9291 31.2225 26.9291 28.1079C26.9291 26.0571 25.1371 24.38 22.9425 24.38C20.7479 24.38 18.9558 26.0475 18.9558 28.1079C18.9558 31.3758 20.2304 34.4521 22.54 36.7521C24.3512 38.5538 26.1146 39.5504 28.8171 40.2883C29.325 40.4321 29.6316 40.9592 29.4879 41.4671C29.3729 41.8888 28.9896 42.1667 28.5679 42.1667Z"
                    fill="#E9E9E9"
                />
            </svg>
        </div>
    </div>
</template>

<script>
import { DateTime } from "luxon"

export default {
    name: "EIMZOCert",

    props: {
        cert: {}
    },

    computed: {
        validPeriod() {
            return DateTime.fromJSDate(this.cert.validTo).toFormat("dd MMM, y")
        },

        isExpired() {
            let end = DateTime.fromJSDate(this.cert.validTo)

            return end.diffNow().as("seconds") < 0
        },

        certType() {
            return this.cert.alias.indexOf("businesscategory") >= 0
                ? this.$l("platon.eimzo_type_business", "Юридик шахс")
                : this.$l("platon.eimzo_type_personal", "Жисмоний шахс")
        },

        isLegalEntity() {
            return this.cert.alias.indexOf("businesscategory") >= 0
        }
    }
}
</script>
